import { render, staticRenderFns } from "./PageArticleListCategory.vue?vue&type=template&id=4b081b28&"
import script from "./PageArticleListCategory.js?vue&type=script&lang=js&"
export * from "./PageArticleListCategory.js?vue&type=script&lang=js&"
import style0 from "./PageArticleListCategory.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageArticleListCategory.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcontent%2FPageArticleListCategory%2FPageArticleListCategory.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports